export const CURRENCY = Object.freeze({
    FIAT_DOLLAR: 'Fiat Dollar',
    GOLD_DOLLAR: 'Gold Dollar',
    SILVER_DOLLAR: 'Silver Dollar',
    GOLD_BACK: 'Goldback',

    FIAT_DOLLAR_ID: 5062,
    GOLD_DOLLAR_ID: 3373,
    SILVER_DOLLAR_ID: 3374,
    GOLD_BACK_ID: 7000,
});